import { render } from "./ProductCharacteristicsRoster23Screen.vue?vue&type=template&id=7a4fb95c&scoped=true"
const script = {}

import "./ProductCharacteristicsRoster23Screen.vue?vue&type=style&index=0&id=7a4fb95c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4fb95c"]])

export default __exports__